import React, {Component} from 'react';
import {translate} from 'react-i18next';
import PropTypes from "prop-types";
import {Link} from 'react-router-dom';
import ErrorForm from '../../App/ErrorForm'


class LoginView extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      authData: {
        email: '',
        password: '',
      },
    };
  }

  handleChange(event) {
    const target = event.target;

    const authData = this.state.authData;
    authData[target.name] = target.value;
    this.setState({
      authData: authData
    });
    this.props.clearError();
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.action({
      ...this.state.authData
    })
  }

  render() {
    const {t, errors, inProgress, onRegister, onForgot} = this.props;
    const {authData} = this.state;
    return (
      <form onSubmit={this.handleSubmit} className="form">
        <div className="form__title form__title--has-lines">{t('sign_in')}</div>
        <div className="form__row">
          <input
            name='email'
            autoComplete='off'
            type="text"
            placeholder={t('email')}
            className="input input--block"
            value={authData.email}
            onChange={this.handleChange}
          />
        </div>
        <div className="form__row">
          <input
            name='password'
            type="password"
            placeholder={t('password')}
            className="input input--block"
            value={authData.password}
            onChange={this.handleChange}
            autoComplete='off'
          />
        </div>
        <ErrorForm
          errors={errors}
        />
        <div className="form__row">
          <div className="login__password-recovery ">
            <Link
              to="#"
              onClick={onForgot}
              className="login__link">{t('forgot_password')}
            </Link>
          </div>
        </div>
        <div className="form__row">
          <button className="form__button" disabled={inProgress} type="submit">{t('sign_in')}</button>
        </div>
        <div className="form__row form__row--bordered">
          <Link
            to="#"
            className="form__button form__button--gray"
            onClick={onRegister}
          >{t('new_account')}</Link>
        </div>
      </form>
    );
  }
}

LoginView.propTypes = {
  action: PropTypes.func.isRequired,
  errors: PropTypes.array,
  inProgress: PropTypes.bool,
  onRegister: PropTypes.func,
  onForgot: PropTypes.func,
};

export default translate('translations')(LoginView);


// WEBPACK FOOTER //
// ./src/components/Customer/Auth/LoginView.js